import React, { useEffect } from 'react';
import styled, { css } from 'styled-components';
import PropTypes from 'prop-types';

import { KEYBOARD_KEYS } from '@CommonConstants';

import useKeyboardNavigation from '@Hooks/useKeyboardNavigation';

import TX from '@Components/Common/Text';
import { ContextMenu, Item } from '@Components/Common/ContextMenu';

const AddingPropertyContextMenu = ({ contextMenuItemList, left, top, resultId }) => {
  const { isKeyPressed: isEnterKeyPressed, selectedIndex } = useKeyboardNavigation(
    contextMenuItemList.length,
    KEYBOARD_KEYS.ENTER,
  );
  // console.log('contextMenuItemList:', contextMenuItemList);
  useEffect(() => {
    if (isEnterKeyPressed) {
      contextMenuItemList[selectedIndex].onClick();
    }
  }, [isEnterKeyPressed, selectedIndex]);

  const inActiveData = ['probability', 'requiredItems'];

  // console.log('resultId:', resultId);

  // console.log('selectedIndex:', selectedIndex);

  return (
    <ContextMenu position={{ left, top: top + 34 }}>
      {contextMenuItemList.map(({ title, Icon, bgText, onClick, type }, index) => {
        const hasImActiveData = inActiveData.includes(type);
        const inActive = !(resultId === 0 && hasImActiveData);
        const isSelected = index === selectedIndex;

        return (
          inActive && (
            <ItemContainer key={title}>
              <Item selected={isSelected} onClick={onClick}>
                {Icon ? (
                  <>
                    <ContextMenuIconContainer>{Icon}</ContextMenuIconContainer>
                    <ContextMenuItemText> {title} </ContextMenuItemText>
                  </>
                ) : (
                  <>
                    <ContextMenuBgTextContainer>
                      <ContextMenuBgText>{bgText}</ContextMenuBgText>
                    </ContextMenuBgTextContainer>

                    <ContextMenuItemText>{title}</ContextMenuItemText>
                  </>
                )}
              </Item>
            </ItemContainer>
          )
        );
      })}
    </ContextMenu>
  );
};

AddingPropertyContextMenu.propTypes = {
  contextMenuItemList: PropTypes.arrayOf(PropTypes.object).isRequired,
  left: PropTypes.number.isRequired,
  top: PropTypes.number.isRequired,
};

const FlexAlignCenterDiv = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;

const IconCSS = css`
  width: 16px;
  height: 16px;
`;

const StyledIconWrapper = styled(FlexAlignCenterDiv)`
  ${IconCSS}
`;

const ItemContainer = styled.div``;

const ContextMenuIconContainer = styled(StyledIconWrapper)`
  margin-right: 8px;
`;

const ContextMenuItemText = styled(TX.FootnoteM)`
  color: ${({ theme, disabled }) => (disabled ? theme.colors.danger : theme.colors.ui_on_1)};
`;

const ContextMenuBgTextContainer = styled(StyledIconWrapper)`
  width: 23px;

  padding: 0px 2px;
  border-radius: 3px;
  margin-right: 8px;

  background-color: ${({ theme }) => theme.colors.ui_3};
`;

const ContextMenuBgText = styled.span`
  ${({ theme }) => css`
    font-size: 10px;
    line-height: 16px;
    letter-spacing: -0.3px;
    font-weight: ${theme.fontWeights.medium};
    color: ${theme.colors.ui_on_3};
  `}
`;

export default React.memo(AddingPropertyContextMenu);

// import React, { useEffect } from 'react';
// import styled, { css } from 'styled-components';
// import PropTypes from 'prop-types';

// import { KEYBOARD_KEYS } from '@CommonConstants';

// import useKeyboardNavigation from '@Hooks/useKeyboardNavigation';

// import TX from '@Components/Common/Text';
// import { ContextMenu, Item } from '@Components/Common/ContextMenu';

// const AddingPropertyContextMenu = ({ contextMenuItemList, left, top, resultId }) => {
//   const { isKeyPressed: isEnterKeyPressed, selectedIndex } = useKeyboardNavigation(
//     contextMenuItemList.length,
//     KEYBOARD_KEYS.ENTER,
//   );
//   console.log('contextMenuItemList:', contextMenuItemList);
//   useEffect(() => {
//     if (isEnterKeyPressed) {
//       contextMenuItemList[selectedIndex].onClick();
//     }
//   }, [isEnterKeyPressed, selectedIndex]);

//   const inActiveData = ['probability', 'requiredItems', 'achievement'];

//   console.log('resultId:', resultId);

//   console.log('selectedIndex:', selectedIndex);

//   return (
//     <ContextMenu position={{ left, top: top + 34 }}>
//       {contextMenuItemList.map(({ title, Icon, bgText, onClick, type }, index) => {
//         const hasImActiveData = inActiveData.includes(type);
//         const inActive = !(resultId === 0 && hasImActiveData);
//         const isSelected = index === selectedIndex;
//         return (
//           inActive && (
//             <ItemContainer key={title}>
//               <Item selected={isSelected} onClick={onClick}>
//                 {Icon ? (
//                   <>
//                     <ContextMenuIconContainer>{Icon}</ContextMenuIconContainer>
//                     <ContextMenuItemText> {title} </ContextMenuItemText>
//                   </>
//                 ) : (
//                   <>
//                     <ContextMenuBgTextContainer>
//                       <ContextMenuBgText>{bgText}</ContextMenuBgText>
//                     </ContextMenuBgTextContainer>

//                     <ContextMenuItemText>{title}</ContextMenuItemText>
//                   </>
//                 )}
//               </Item>
//             </ItemContainer>
//           )
//         );
//       })}
//     </ContextMenu>
//   );
// };

// AddingPropertyContextMenu.propTypes = {
//   contextMenuItemList: PropTypes.arrayOf(PropTypes.object).isRequired,
//   left: PropTypes.number.isRequired,
//   top: PropTypes.number.isRequired,
// };

// const FlexAlignCenterDiv = styled.div`
//   display: flex;
//   align-items: center;
//   justify-content: center;
// `;

// const IconCSS = css`
//   width: 16px;
//   height: 16px;
// `;

// const StyledIconWrapper = styled(FlexAlignCenterDiv)`
//   ${IconCSS}
// `;

// const ItemContainer = styled.div``;

// const ContextMenuIconContainer = styled(StyledIconWrapper)`
//   margin-right: 8px;
// `;

// const ContextMenuItemText = styled(TX.FootnoteM)`
//   color: ${({ theme, disabled }) => (disabled ? theme.colors.danger : theme.colors.ui_on_1)};
// `;

// const ContextMenuBgTextContainer = styled(StyledIconWrapper)`
//   width: 23px;

//   padding: 0px 2px;
//   border-radius: 3px;
//   margin-right: 8px;

//   background-color: ${({ theme }) => theme.colors.ui_3};
// `;

// const ContextMenuBgText = styled.span`
//   ${({ theme }) => css`
//     font-size: 10px;
//     line-height: 16px;
//     letter-spacing: -0.3px;
//     font-weight: ${theme.fontWeights.medium};
//     color: ${theme.colors.ui_on_3};
//   `}
// `;

// export default React.memo(AddingPropertyContextMenu);
